import {
    iconGridViewOutline,
    iconListViewOutline,
} from '@shared/helpers/icons'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {trans} from '../../../../../helpers'
import type {AdsListPresentation} from '../../AdsModuleTypes'
import {AdsSortDropdown} from './AdsSortDropdown'

interface ItemsListControlsProps {
    totalItemsCount: number
    adsListPresentation: AdsListPresentation
    setAdsListPresentation: (value: AdsListPresentation) => void
}

// Действия со списком объявлений: вид карточек, сортировка и т.п.
export function AdsListActionsPanel(props: ItemsListControlsProps) {
    const {
        totalItemsCount,
        adsListPresentation,
        setAdsListPresentation,
    } = props

    if (totalItemsCount <= 0) {
        return null
    }

    return (
        <div className="d-flex flex-row gap-6">
            <div className="d-flex flex-row gap-2">
                <IconButton
                    path={iconGridViewOutline}
                    size={22}
                    color={adsListPresentation === 'grid' ? 'primary' : 'dark'}
                    tooltip={trans().ads.list.presentation.grid}
                    onClick={() => setAdsListPresentation('grid')}
                />
                <IconButton
                    path={iconListViewOutline}
                    size={22}
                    color={adsListPresentation === 'list' ? 'primary' : 'dark'}
                    tooltip={trans().ads.list.presentation.list}
                    onClick={() => setAdsListPresentation('list')}
                />
            </div>
            <AdsSortDropdown />
        </div>
    )
}
